import React from 'react';
import PropTypes from 'prop-types';
import { Radio } from 'antd';

import './style.less';

const RadioGroup = ({ children, ...radioGroupProps }) => (
  <Radio.Group className="radio-group" {...radioGroupProps}>
    {children}
  </Radio.Group>
);

RadioGroup.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default RadioGroup;
